/* eslint-disable jsx-a11y/anchor-is-valid */
import './style.scss'

import { Form, Formik, FormikProps } from 'formik'
import { t } from 'i18next'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap-v5'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import { HTTP_RESPONSE_STATUS } from 'setup/constants/Http'
import { ToastDefaultConfig } from 'setup/toast/ToastConfig'
import { ATTENDANCE_STATUS, clientTimeZoneOffset, DELIVERY_STATUS, SideMenuStatus, TicketStatus } from 'app/utils/common/constants'
import { TicketSource } from 'app/utils/common/enum'
import { TicketModel, TicketPackageDetail } from '../../models'
import { ticketApi } from '../../redux/TicketApi'
import { customerApi } from 'app/modules/customers/redux'
import { PackageDetails } from './components/PackageDetails'
import { PackageDetailSkeleton } from './skeletons/PackageDetailSkeleton'
import { selectCentroOrderSourceData, selectCustomerTagsData, selectTicketFlagData, selectTicketOpeningCancelModal, ticketActions } from '../../redux/TicketSlice';
import { useAppDispatch, useAppSelector } from 'setup/redux/Hooks'
import { Popover, OverlayTrigger, ListGroup, Col } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { ModalUndoDeliveryAction } from './components/UndoDeliveryActionModal'
import { mapStatus } from '../../attendance-delivery/AttendanceDelivery'
import { ACTION_STATUS, PackageTicketCompleteLabel } from 'app/utils/common/constants/TicketStatus';
import _ from "lodash"
import { EventLogName, EventLogSource } from 'app/utils/common/constants/EventLogName';
import { TicketAttendanceSheetModel, TicketAttendanceSheetRequest } from '../../models/TicketAttendanceDelivery'
import { selectMenuConfig } from 'app/modules/auth'
import { syncTicketStatusById } from 'app/modules/trip/redux/TripSlice'
type Props = {
  className?: string
  data: TicketModel | null
  ticketPackage?: TicketPackageDetail
  isShow?: boolean
  onHide?: () => void
  onCancel?: (data: TicketModel) => void
  onReschedule?: (data: TicketModel) => void
  onReloadShift?: (shiftTicket?: number) => void
  updateIsRefundPackageStore?: (ticketPackage: TicketPackageDetail) => void
  rtl?: boolean
}

export interface IForm {
  backupNumber: string
  other_replicateTickets: boolean
  service_provider_comment: string,
  note_order: string,
  nationalId: string,
  rating_comment: string
}

type PaymentProof = {
  type?: string
  url?: string
  uploaded_at?: string
}

const parseInvoicePaymentProof = (invoice?: string): PaymentProof | null => {
  if (!invoice) return null
  try {
    const parsed = JSON.parse(invoice)
    return parsed?.paymentProof || null
  } catch {
    return null
  }
}

let initValues = {
  backupNumber: '',
  other_replicateTickets: false,
  service_provider_comment: '',
  note_order: '',
  nationalId: '',
  rating_comment: '',
}

const validator = Yup.object({
  backupNumber: Yup.string().phoneAr('CREATE_ORDER_DRAWER.SECTION_1.VALID.PHONE_FORMAT'),
})

const ViewPackageModal: React.FC<Props> = ({
  className,
  data,
  ticketPackage,
  isShow,
  rtl,
  onHide,
  onCancel,
  onReschedule,
  onReloadShift,
  updateIsRefundPackageStore,
}) => {
  const dispatch: any = useAppDispatch();
  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [loadingUpdateStatus, setLoadingUpdateStatus] = useState(false)
  const [packageData, setPackageData] = useState<TicketPackageDetail | null>(null)
  const flagData = useAppSelector(selectTicketFlagData)
  const customerTagsData = useAppSelector(selectCustomerTagsData)
	const isShowCancelPackageModal = useAppSelector(selectTicketOpeningCancelModal);
  const formikRef = useRef<FormikProps<IForm>>(null)
  const isTicketCompletedOrCanceled: boolean = Boolean(data?.status && ["Completed", "Canceled"].some(item => data?.status.includes(item)))
  const isAssignedTicket: boolean = Boolean(packageData?.ticketWorkers?.length && packageData?.packageDetails?.numberOfWorker && packageData?.ticketWorkers?.filter(x => x.id).length === packageData?.packageDetails?.numberOfWorker)
  const enabledDisplayAttendanceAndDeliveryActions: boolean = !isTicketCompletedOrCanceled && isAssignedTicket
  const isDisplayUtilitiesButton: boolean = Boolean(!loading && data?.status === TicketStatus.Inprogress && !!data?.packageId && data?.packageSubmitId && packageData?.packageDetails.sourceType !== TicketSource.B8AK)
  const isDisplayModifyButton: boolean = Boolean(!loading && !isTicketCompletedOrCanceled && data?.status != TicketStatus.Delivered && !!data?.packageId && data?.packageSubmitId && packageData?.packageDetails.sourceType !== TicketSource.B8AK)
  const [openUndoDeliveryAction, setOpenUndoDeliveryAction] = useState<boolean>(false)
  const [paymentMethod, setPaymentMethod] = useState('')
  const [paymentStatus, setPaymentStatus] = useState('')
  const [statusDis, setStatusDis] = useState('');
  const [attendanceDeliveryData, setAttendanceDeliveryData] = useState<TicketAttendanceSheetModel[]>([]);
  const centroOrderSourceData = useAppSelector(selectCentroOrderSourceData);
  const [centroOrderSource, setCentroOrderSource] = useState('')
  const menuConfig = useAppSelector(selectMenuConfig);
  const [invoiceFile, setInvoiceFile] = useState<File | null>(null)
  const [invoicePreviewUrl, setInvoicePreviewUrl] = useState('')
  const [invoicePreviewType, setInvoicePreviewType] = useState<'image' | 'pdf' | ''>('')
  const [invoiceFileError, setInvoiceFileError] = useState('')
  const [removeExistingInvoice, setRemoveExistingInvoice] = useState(false)
  const [showPaymentMethodConfirm, setShowPaymentMethodConfirm] = useState(false)
  const [pendingPaymentMethod, setPendingPaymentMethod] = useState<string | null>(null)
  const isInvoiceReadOnly = packageData?.packageDetails?.sourceType === TicketSource.PWA

  useEffect(() => {
    const details = packageData?.packageDetails
    if (!details) {
      return
    }

    setPaymentMethod(details.paymentMethod || '')
    setPaymentStatus(details.paymentStatus || '')
  }, [packageData?.packageDetails?.id, packageData?.packageDetails?.paymentMethod, packageData?.packageDetails?.paymentStatus])

  const invoicePaymentProof = useMemo(
    () => parseInvoicePaymentProof(packageData?.packageDetails?.invoice),
    [packageData?.packageDetails?.invoice]
  )

  const clearInvoiceFile = () => {
    if (invoicePreviewUrl) {
      URL.revokeObjectURL(invoicePreviewUrl)
    }
    setInvoicePreviewUrl('')
    setInvoicePreviewType('')
    setInvoiceFile(null)
  }

    const handleInvoiceFileSelected = (file: File) => {
      if (isInvoiceReadOnly) {
        return
      }
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf', 'image/jpg']
      const maxSizeBytes = 5 * 1024 * 1024
      const extension = file.name.split('.').pop()?.toLowerCase() || ''
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf']

    if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(extension)) {
      setInvoiceFileError(t('CREATE_ORDER_DRAWER.INVOICE_UPLOAD_INVALID_TYPE'))
      return
    }

    if (file.size > maxSizeBytes) {
      setInvoiceFileError(t('CREATE_ORDER_DRAWER.INVOICE_UPLOAD_SIZE_EXCEED'))
      return
    }

    setInvoiceFileError('')
    setRemoveExistingInvoice(false)
    clearInvoiceFile()
      setInvoiceFile(file)
      const previewUrl = URL.createObjectURL(file)
      setInvoicePreviewUrl(previewUrl)
      setInvoicePreviewType(file.type === 'application/pdf' || extension === 'pdf' ? 'pdf' : 'image')
      if (paymentMethod && paymentMethod.toLowerCase() === 'invoice') {
        setPaymentStatus('paid')
      }
    }

  const handleInvoiceRemove = () => {
    if (isInvoiceReadOnly) {
      return
    }
    setInvoiceFileError('')
    if (invoiceFile) {
      clearInvoiceFile()
      return
    }
    if (invoicePaymentProof?.url) {
      setRemoveExistingInvoice(true)
    }
  }

  const handleInvoiceView = () => {
    if (invoicePreviewUrl) {
      window.open(invoicePreviewUrl, '_blank')
      return
    }
    if (invoicePaymentProof?.url) {
      window.open(invoicePaymentProof.url, '_blank')
    }
  }

  useEffect(() => {
    return () => {
      if (invoicePreviewUrl) {
        URL.revokeObjectURL(invoicePreviewUrl)
      }
    }
  }, [invoicePreviewUrl])

    useEffect(() => {
      // Keep invoice selection when payment status changes
    }, [paymentStatus])

  useEffect(() => {
    if (!isShow) {
      setInvoiceFileError('')
      setRemoveExistingInvoice(false)
      clearInvoiceFile()
      setShowPaymentMethodConfirm(false)
      setPendingPaymentMethod(null)
    }
  }, [isShow])

  useEffect(() => {
    setRemoveExistingInvoice(false)
    setInvoiceFileError('')
    clearInvoiceFile()
  }, [packageData?.packageDetails?.invoice])

  const normalizePaymentMethod = (value?: string | null) => (value || '').trim().toLowerCase()

  const applyPaymentMethod = (nextPaymentMethod: string) => {
    setPaymentMethod(nextPaymentMethod)
    const normalizedMethod = normalizePaymentMethod(nextPaymentMethod)
    if (normalizedMethod === 'onlinepaymentlinksms' || normalizedMethod === 'invoice') {
      setPaymentStatus('pending')
    } else if (normalizedMethod === 'cash') {
      setPaymentStatus('unpaid')
    }
  }

  const handlePaymentMethodChange = (nextPaymentMethod: string) => {
    if (!nextPaymentMethod) {
      return
    }

    const currentSelectedMethod = normalizePaymentMethod(paymentMethod || packageData?.packageDetails?.paymentMethod)
    const normalizedNextMethod = normalizePaymentMethod(nextPaymentMethod)
    if (currentSelectedMethod === normalizedNextMethod) {
      return
    }

    if (currentSelectedMethod === 'onlinepaymentlinksms' && normalizedNextMethod !== 'onlinepaymentlinksms') {
      setPendingPaymentMethod(nextPaymentMethod)
      setShowPaymentMethodConfirm(true)
      return
    }

    applyPaymentMethod(nextPaymentMethod)
  }

  const handleConfirmPaymentMethodChange = () => {
    if (pendingPaymentMethod) {
      applyPaymentMethod(pendingPaymentMethod)
    }

    setPendingPaymentMethod(null)
    setShowPaymentMethodConfirm(false)
  }

  const handleDismissPaymentMethodChange = () => {
    setPendingPaymentMethod(null)
    setShowPaymentMethodConfirm(false)
  }

  const handleUpdateStatusByTicket = async (status: string) => {
    if (!data) {
      return
    }
    const updateStatus = mapStatus.find(e => e.status === status)?.update || '';
    setLoadingUpdateStatus(true)
    try {
      const resp = (await ticketApi.putTickerStatusAllWorker({
        ticketId: data.id,
        status: updateStatus
      }).catch(e => ({ data: undefined, }))).data

      if (resp !== undefined && data) {
        const newTicketModalData = _.cloneDeep(data)
        if (status === ACTION_STATUS.UndoDelivery) {
          newTicketModalData.status = TicketStatus.InprogressConfirmed
          newTicketModalData.statusLabel = TicketStatus.Inprogress
        }
        if (status === ATTENDANCE_STATUS.Attendant) {
          newTicketModalData.status = updateStatus
          newTicketModalData.statusLabel = TicketStatus.Inprogress
        }
        else if (status === ATTENDANCE_STATUS.Unattendant) {
          newTicketModalData.status = TicketStatus.Inprogress
          newTicketModalData.statusLabel = TicketStatus.Inprogress
        }
        else if (status.includes("Undelivered")) {
          newTicketModalData.status = updateStatus
          newTicketModalData.statusLabel = TicketStatus.Canceled
        }
        else if (status === DELIVERY_STATUS.Delivered) {
          newTicketModalData.status = updateStatus
          newTicketModalData.statusLabel = TicketStatus.Inprogress
        }

        // Reflect the new status in the Trip list ("Ticket Status" column) and the
        // Manual Routing modal ("Status" column), which both read from the trip store.
        dispatch(
          syncTicketStatusById({
            ticketId: data.id,
            status: newTicketModalData.status,
          })
        )

        getData(() => {
          dispatch(ticketActions.setOpeningViewPackageModal(newTicketModalData))
          onReloadShift && onReloadShift(data?.shift)
        })
      }
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setLoadingUpdateStatus(false)
      openUndoDeliveryAction && setOpenUndoDeliveryAction(false)
    }
  }

  const handlePickedUpTicket = async (ticketId: string) => {
    if (!data) {
      return
    }
    setLoadingUpdateStatus(true)
    try {
      const resp = await ticketApi.pickedUpTicket({ ticketId }).catch(e => ({ data: undefined }))

      if (resp.data !== undefined && data) {
        const newTicketModalData = _.cloneDeep(data)
        newTicketModalData.status = TicketStatus.Worker_Picked_Up
        newTicketModalData.statusLabel = TicketStatus.Inprogress

        getData(() => {
          dispatch(ticketActions.setOpeningViewPackageModal(newTicketModalData))
          onReloadShift && onReloadShift(data?.shift)
        })
      }
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setLoadingUpdateStatus(false)
    }
  }

  const attendanceAndDeliveryActionsButtonStatus = () => {
    const isUnattendantSelected: boolean = (packageData?.ticketWorkers || []).every(item => item?.attendantEvent === EventLogName.Package_Ticket_Declined);
    const enabledAttendanceActions: boolean = Boolean(data?.status && !isTicketCompletedOrCanceled && ([TicketStatus.Inprogress, TicketStatus.InprogressConfirmed].includes(data?.status) || isUnattendantSelected) && enabledDisplayAttendanceAndDeliveryActions)
    const enabledDeliveryActions: boolean = Boolean(data?.status && !isTicketCompletedOrCanceled && ![TicketStatus.Inprogress].includes(data?.status) && !isUnattendantSelected)
    const enabledUndoDeliveryAction: boolean = (packageData?.ticketWorkers || []).some(item => [EventLogName.Package_Ticket_Delivered, EventLogName.Package_Ticket_Undelivered].includes(item.attendantEvent || ""))
    const enabledPickedUpActions: boolean = Boolean(packageData?.eventLogs && packageData?.eventLogs.length > 0 && packageData?.eventLogs[packageData?.eventLogs.length - 1].event !== EventLogName.Worker_Picked_Up && !isUnattendantSelected)
    return ({
      Attendant: {
        enabled: enabledAttendanceActions && data?.status !== TicketStatus.InprogressConfirmed,
        selected: [TicketStatus.InprogressConfirmed, TicketStatus.Delivered, TicketStatus.SPUndelivered_CustomerNotReachable, TicketStatus.SPUndelivered_NoFemalePresent, TicketStatus.SPUndelivered_Other].includes(data?.status || ""),
      },
      Unattendant: {
        enabled: enabledAttendanceActions && !isUnattendantSelected,
        selected: isUnattendantSelected,
      },
      Delivered: {
        enabled: enabledDeliveryActions &&  data?.status !== TicketStatus.Delivered,
        selected: data?.status === TicketStatus.Delivered,
      },
      UndeliveredCustomerNotReachable: {
        enabled: enabledDeliveryActions && data?.status !== TicketStatus.SPUndelivered_CustomerNotReachable,
        selected: data?.status === TicketStatus.SPUndelivered_CustomerNotReachable,
      },
      UndeliveredNoFemale: {
        enabled: enabledDeliveryActions && data?.status !== TicketStatus.SPUndelivered_NoFemalePresent,
        selected: data?.status === TicketStatus.SPUndelivered_NoFemalePresent,
      },
      UndeliveredOther: {
        enabled: enabledDeliveryActions && data?.status !== TicketStatus.SPUndelivered_Other,
        selected: data?.status === TicketStatus.SPUndelivered_Other,
      },
      UndoDelivery: {
        enabled: enabledUndoDeliveryAction,
        selected: false
      },
      PickedUp: {
        enabled: enabledPickedUpActions && data?.status === TicketStatus.Delivered,
        selected: packageData?.eventLogs && packageData?.eventLogs.length > 0 && packageData?.eventLogs[packageData?.eventLogs.length - 1].event === EventLogName.Worker_Picked_Up
      }
    })
  }

  const { Attendant, Unattendant, Delivered, UndeliveredCustomerNotReachable, UndeliveredNoFemale, UndeliveredOther, UndoDelivery, PickedUp } = attendanceAndDeliveryActionsButtonStatus()
  const PopoverAttendanceAndDeliveryActions = (<Popover className='attendance-and-delivery-actions-popover'>
  <ListGroup as="ol" variant="flush" className='attendance-and-delivery-actions-container'>
    <ListGroup.Item
      as="li"
      className="d-flex justify-content-between align-items-start"
      style={{ padding: "6px 13px" }}
    >
      <Col xs={12} className='p-0'>
        <Col xs={12}>
          <div className="fw-bolder">{t("VIEW_PACKAGE_MODAL.ATTENDANCE_ACTIONS")}</div>
        </Col>
        <Col xs={12} className='p-0'>
          <Button variant="outline-light" disabled={!Attendant.enabled} onClick={() => handleUpdateStatusByTicket(ATTENDANCE_STATUS.Attendant)} className={`btn-block btn-sm px-2 py-1 w-100 d-flex justify-content-start align-items-center rounded-0 action--success ${Attendant.selected && "action--selected--success"}`}><Icon.Check size={18} /><p className='text-nowrap p-0 m-0 ms-2'>{t("VIEW_PACKAGE_MODAL.ATTENDANT")}</p></Button>{' '}
        </Col>
        <Col xs={12} className='p-0'>
          <Button variant="outline-light" disabled={!Unattendant.enabled} onClick={() => handleUpdateStatusByTicket(ATTENDANCE_STATUS.Unattendant)} className={`btn-block btn-sm px-2 py-1 w-100 d-flex justify-content-start align-items-center rounded-0 action--danger ${Unattendant.selected && "action--selected--danger"}`}><Icon.X size={18} /><p className='text-nowrap p-0 m-0 ms-2'>{t("VIEW_PACKAGE_MODAL.NOT_ATTENDANT")}</p></Button>{' '}
        </Col>
      </Col>
    </ListGroup.Item>
    <ListGroup.Item
      as="li"
      className="d-flex justify-content-between align-items-start"
      style={{ padding: "6px 13px" }}
    >
      <Col xs={12} className='p-0'>
        <Col xs={12}>
          <div className="fw-bolder">{t("VIEW_PACKAGE_MODAL.DELIVERY_ACTIONS")}</div>
        </Col>
        <Col xs={12} className='p-0'>
          <Button variant="outline-light" disabled={!Delivered.enabled} onClick={() => handleUpdateStatusByTicket(DELIVERY_STATUS.Delivered)} className={`btn-block btn-sm px-2 py-1 w-100 d-flex justify-content-start align-items-center rounded-0 action--success ${Delivered.selected && "action--selected--success"}`}><Icon.Check size={18} /><p className='text-nowrap p-0 m-0 ms-2'>{t("VIEW_PACKAGE_MODAL.DELIVERED")}</p></Button>{' '}
        </Col>
        <Col xs={12} className='p-0'>
          <Button variant="outline-light" disabled={!UndeliveredCustomerNotReachable.enabled} onClick={() => handleUpdateStatusByTicket(DELIVERY_STATUS.UndeliveredCustomerNotReachable)} className={`btn-block btn-sm px-2 py-1 w-100 d-flex justify-content-start align-items-center rounded-0 action--danger ${UndeliveredCustomerNotReachable.selected && "action--selected--danger"}`}><Icon.X size={18} /><p className='text-nowrap p-0 m-0 ms-2'>{t("VIEW_PACKAGE_MODAL.UNDELIVERED_CUSTOMER_NOT_REACHABLE")}</p></Button>{' '}
        </Col>
        <Col xs={12} className='p-0'>
          <Button variant="outline-light" disabled={!UndeliveredNoFemale.enabled} onClick={() => handleUpdateStatusByTicket(DELIVERY_STATUS.UndeliveredNoFemale)} className={`btn-block btn-sm px-2 py-1 w-100 d-flex justify-content-start align-items-center rounded-0 action--danger ${UndeliveredNoFemale.selected && "action--selected--danger"}`}><Icon.X size={18} /><p className='text-nowrap p-0 m-0 ms-2'>{t("VIEW_PACKAGE_MODAL.UNDELIVERED_NO_FEMALE")}</p></Button>{' '}
        </Col>
        <Col xs={12} className='p-0'>
          <Button variant="outline-light" disabled={!UndeliveredOther.enabled} onClick={() => handleUpdateStatusByTicket(DELIVERY_STATUS.UndeliveredOther)} className={`btn-block btn-sm px-2 py-1 w-100 d-flex justify-content-start align-items-center rounded-0 action--danger ${UndeliveredOther.selected && "action--selected--danger"}`}><Icon.X size={18} /><p className='text-nowrap p-0 m-0 ms-2'>{t("VIEW_PACKAGE_MODAL.UNDELIVERED_OTHER_REASON")}</p></Button>{' '}
        </Col>
        <Col xs={12} className='p-0'>
          <Button variant="outline-light" disabled={!PickedUp.enabled} onClick={() => data && handlePickedUpTicket(data.id)} className={`btn-block btn-sm px-2 py-1 w-100 d-flex justify-content-start align-items-center rounded-0 action--success ${PickedUp.selected && "action--selected--success"}`}><Icon.Check size={18} /><p className='text-nowrap p-0 m-0 ms-2'>{t("VIEW_PACKAGE_MODAL.PICKED_UP")}</p></Button>{' '}
        </Col>
      </Col>
    </ListGroup.Item>
    <ListGroup.Item
      as="li"
      className="d-flex justify-content-between align-items-start"
      style={{ padding: "6px 13px" }}
    >
      <Col xs={12} className='p-0'>
        <Button variant="outline-light" disabled={!UndoDelivery.enabled} onClick={() => setOpenUndoDeliveryAction(true)} className='btn-block btn-sm px-2 py-1 w-100 d-flex justify-content-start align-items-center rounded-0 action--warning'><Icon.ExclamationTriangleFill size={18} color={!UndoDelivery.enabled ? '#AEAEAE' : '#FFC20F'} /><p className='text-nowrap p-0 m-0 ms-2'>{t("VIEW_PACKAGE_MODAL.UNDO_DELIVERY_ACTION")}</p></Button>{' '}
      </Col>
    </ListGroup.Item>
  </ListGroup>
</Popover>)

  const getData = async (callback?: () => void) => {
    if (!data) return
    const tmpInitValues = {...initValues};
    tmpInitValues.note_order = data.customerComments || '';
    tmpInitValues.rating_comment = ticketPackage?.customerRatingComments || '';
    initValues = tmpInitValues;
    setLoading(true)
    setPackageData(null)
    ticketApi.getPackageDetail(data.id).then((res) => {
      if (res.status === HTTP_RESPONSE_STATUS.SUCCESS) {
        callback && callback();
        if (res.data.eventLogs.length > 0) {
          res.data.eventLogs.map((item) => {
            item.event =
              item.event === 'Ticket_Canceled with refund'
                ? 'Ticket_Canceled_With_Refund'
                : item.event
            return item
          })

          let tempEventLogs = []
          for (let i = 0; i < res.data.eventLogs.length; i++) {
            let element = res.data.eventLogs[i]
            if (element.event === EventLogName.Package_Ticket_Undo_Delivery &&
              ( element.source === EventLogSource.B8akDashboard || 
                element.source === EventLogSource.CentroDashboard || 
                element.source === EventLogSource.OnlineBooking )
            ) {
              let existElementIndex = tempEventLogs.findIndex(
                (te) => te.dateTime === element.dateTime && te.source === element.source
              )
              if (existElementIndex < 0) {              
                tempEventLogs.push(element)
        }
            } else {
              tempEventLogs.push(element)
            }
          }
          res.data.eventLogs = [...tempEventLogs]    
        }

        if (
          res.data.customer.id.length > 0 &&
          (res.data?.packageDetails.sourceType === TicketSource.EXTERNAL || res.data?.packageDetails.sourceType === TicketSource.PWA)
        ) {
          customerApi
            .getCustomerTicketStatistic(res.data.customer.id || '', false)
            .then((resStatistic) => {
              if (resStatistic.status === HTTP_RESPONSE_STATUS.SUCCESS) {
                const newPackageData = {
                  ...res.data,
                  customer: {
                    ...res.data.customer,
                    statistics: { ...resStatistic.data },
                  },
                }
                setPackageData(newPackageData)
                updateIsRefundPackageStore?.(newPackageData)
              }
            })
        } else {
          setPackageData(res.data)
          updateIsRefundPackageStore?.(res.data)
        }
        
        formikRef.current?.setValues((s) => ({
          ...s,
          ...(res.data.customer.backupNumber && { backupNumber: res.data.customer.backupNumber }),
          ...(res.data.customer.nationalId && { nationalId: res.data.customer.nationalId }),
          service_provider_comment: res.data.noteForProviderApp || '',
          other_replicateTickets: res.data.applySPNoteForAllPackage,
          rating_comment: res.data.customerRatingComments || '',
        }))
      } else {
        toast.error(res.message, ToastDefaultConfig())
      }
      if (data.sourceType === TicketSource.EXTERNAL || res.data?.packageDetails.sourceType === TicketSource.PWA) {        
        setCentroOrderSource(res.data.centroSourceId ? res.data.centroSourceId.toString() : '');
        dispatch(ticketActions.getCentroOrderSource({id: ''}));
      }
    })
    const paramAttendanceDelivery: TicketAttendanceSheetRequest = {
      spIds: [],
      cityIds: [],
      clientTimeZone: clientTimeZoneOffset,
      dateSearch: data.scheduledVisitDateTime,
    }
    const resp = await (await ticketApi.getAttendanceDelivery(paramAttendanceDelivery).catch(e => ({ data: undefined, }))).data;
    setAttendanceDeliveryData(resp || []);
  }

  const onConfirmWorkerUndoDeliveryAction = () => {
    if (!data) {
      return
    }
    handleUpdateStatusByTicket(ACTION_STATUS.UndoDelivery)
  }

  const onSubmit = async (values: IForm) => {
    setSubmitting(true)

    if (data) {
      try {
        const canEditInvoice = !isInvoiceReadOnly
        const previousPaymentStatus = packageData?.packageDetails.paymentStatus || ''
        const previousPaymentMethod = packageData?.packageDetails.paymentMethod || ''
        const isPaymentStatusChanged = previousPaymentStatus.toLowerCase() !== (paymentStatus || '').toLowerCase()
        const isPaymentMethodChanged = previousPaymentMethod.toLowerCase() !== (paymentMethod || '').toLowerCase()
        const hasPaymentChange = isPaymentStatusChanged || isPaymentMethodChanged
        const requestData = {
          id: data.id,
          backUpNumber: values.backupNumber || '',
          replicateAllTicket: values.other_replicateTickets,
          noteForProviderApp: values.service_provider_comment || '',
          packageSubmitId: hasPaymentChange ? packageData?.packageDetails.id : null,
          paymentStatus: hasPaymentChange ? paymentStatus : null,
          paymentMethod: isPaymentMethodChanged ? paymentMethod : null,
          customerId: data.customerId,
          centroSourceId: Number(centroOrderSource),
          invoiceFile: canEditInvoice ? (invoiceFile || null) : null,
          removePaymentProof: canEditInvoice && removeExistingInvoice && !invoiceFile
        }
        const resp = await ticketApi.updatePackageDetail(requestData)
        if (resp.status !== HTTP_RESPONSE_STATUS.SUCCESS) {
          toast.error(resp.message, ToastDefaultConfig())
          setSubmitting(false)
          return
        }

        if (invoiceFile || removeExistingInvoice || hasPaymentChange) {
          await getData()
        }

        setSubmitting(false)
        toast.success(t('CREATE_TICKET_MODAL.TICKET_MODIFY_COMPLETED'), ToastDefaultConfig())
      } catch (error) {
        setSubmitting(false)
        return
      }
    }
  }

  useEffect(() => {
    if(isShow && !isShowCancelPackageModal){
      getData()
    }
  }, [isShow, isShowCancelPackageModal])

  useEffect(() => {
    if (!!packageData) {
      setLoading(false)
    }
  }, [packageData])

  useEffect(() => {
    if (isShow && !!packageData &&
      packageData.status && data &&
      packageData.status !== data?.status
    ) {
      const newTicketModalData = _.cloneDeep(data)
      newTicketModalData.status = packageData.status

      if (
        newTicketModalData.status.indexOf(TicketStatus.Inprogress) > -1 ||
        newTicketModalData.status === TicketStatus.Delivered
      ) {
        newTicketModalData.statusLabel = TicketStatus.Inprogress
      } else if (
        newTicketModalData.status.indexOf(TicketStatus.Undelivered) > -1 ||
        newTicketModalData.status.indexOf(TicketStatus.Canceled) > -1
      ) {
        newTicketModalData.statusLabel = TicketStatus.Canceled
      } else if (newTicketModalData.status === TicketStatus.Completed_No_Customer_Rating) {
        newTicketModalData.statusLabel = PackageTicketCompleteLabel
      } else {
        newTicketModalData.statusLabel = packageData.status
      }
      dispatch(ticketActions.setOpeningViewPackageModal(newTicketModalData))
      onReloadShift && onReloadShift(data?.shift)
    }
  }, [isShow, packageData])

  useEffect(() => {
    if (ticketPackage) setPackageData(ticketPackage)
  }, [ticketPackage])

  const handleViewInvoice = () => {
    window.open(`${process.env.REACT_APP_INVOICE_URL}?ticket=${data?.id}`, '_blank')
  }

  if (!isShow || !data) return <></>
  const flags = flagData.data.filter((x: any) => x.id === data.id)
  const centroOrderSourceDataSort = centroOrderSourceData.slice().sort((a, b) => { return a.order - b.order })

  return (
    <>
      <ModalUndoDeliveryAction isLoading={loadingUpdateStatus} isShow={openUndoDeliveryAction} onHide={() => setOpenUndoDeliveryAction(false)} onConfirm={onConfirmWorkerUndoDeliveryAction} />
    <Modal
      show={isShow}
      onHide={onHide}
      backdrop='static'
      keyboard={false}
      size='xl'
      className={className}
    >
      <Formik
        validationSchema={validator}
          initialValues={_.cloneDeep(initValues)}
        onSubmit={onSubmit}
        innerRef={formikRef}
        enableReinitialize={true}
      >
          {(formikHelper) => {
          const {
            handleSubmit,
            setValues,
            resetForm,
            values,
            errors,
            } = formikHelper
          return (
            <Form onSubmit={handleSubmit} onReset={() => resetForm()}>
              <Modal.Header closeButton className='header-primary'>
                <Modal.Title className='fw-normal'>{t('VIEW_TICKET_MODAL.TITLE')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {flags.length > 0 &&
                  flags.map((flag, index) => (
                    <div className={'alert px-10 py-3 ' + flag.flagLevel} key={index}>
                      <strong>{rtl ? flag.flagDescriptionAr : flag.flagDescription}</strong>
                    </div>
                  ))}
                {loading ? (
                  <PackageDetailSkeleton />
                ) : (
                  <PackageDetails
                    statusDis={statusDis}
                    paymentStatus={paymentStatus}
                    setPaymentStatus={setPaymentStatus}
                    paymentMethod={paymentMethod}
                    onPaymentMethodChange={handlePaymentMethodChange}
                    values={values}
                    setValues={setValues}
                    errors={errors}
                    dataPackage={packageData}
                    dataTicket={data}
                    rtl={rtl}
                    dataCustomerTags={customerTagsData}
                      form={formikHelper}
                      disabled={submitting || loadingUpdateStatus}
                    dataCentroOrderSource={centroOrderSourceDataSort}
                    centroOrderSource={centroOrderSource}
                    setCentroOrderSource={setCentroOrderSource}
                    invoiceProof={invoicePaymentProof}
                    invoicePreviewUrl={invoicePreviewUrl}
                    invoicePreviewType={invoicePreviewType}
                    invoiceFileError={invoiceFileError}
                    hasInvoiceFile={!!invoiceFile}
                    removeExistingInvoice={removeExistingInvoice}
                    onInvoiceFileSelected={handleInvoiceFileSelected}
                    onInvoiceRemove={handleInvoiceRemove}
                    onInvoiceView={handleInvoiceView}
                  />
                )}
              </Modal.Body>
              <Modal.Footer className='justify-content-between modal-footer-gray'>
                <div>
                  <Button variant='light' className='px-10 fw-normal h-50px' onClick={onHide}>
                    {t('CLOSE')}
                  </Button>
                    {(packageData?.packageDetails.sourceType === TicketSource.EXTERNAL || packageData?.packageDetails.sourceType === TicketSource.PWA) && (
                    <Button
                      variant='dark'
                      className='px-10 fw-normal h-50px ms-4'
                      onClick={() => handleSubmit()}
                    >
                      {submitting && (
                        <div
                          className='spinner-border spinner-border-sm me-2'
                          role='status'
                          aria-hidden='true'
                        ></div>
                      )}
                      {t('SAVE')}
                    </Button>
                  )}
                </div>
                <div>
                    {isDisplayUtilitiesButton && <Button
                          variant='danger'
                          className='px-10 fw-normal h-50px'
                          onClick={() => onCancel?.(data)}
                        >
                          {t('CANCEL')}
                    </Button>}
                    {!loading && Boolean(data?.packageId) && <>
                      <OverlayTrigger trigger="click" placement="top" show={(openUndoDeliveryAction || loadingUpdateStatus) ? false : undefined} overlay={PopoverAttendanceAndDeliveryActions}>
                        {({ ref, ...triggerHandler }) => (
                          <>

                        <Button
                          variant='warning'
                              className={`px-10 fw-normal h-50px ${isDisplayUtilitiesButton && "ms-4"}`}
                              {...triggerHandler}
                              ref={ref}
                              disabled={loadingUpdateStatus || !enabledDisplayAttendanceAndDeliveryActions}
                        >
                              {loadingUpdateStatus && (
                                <div
                                  className='spinner-border spinner-border-sm me-2'
                                  role='status'
                                  aria-hidden='true'
                                ></div>
                              )}
                              {t('VIEW_PACKAGE_MODAL.ATTENDANCE_AND_DELIVERY_ACTIONS')}
                        </Button>
                      </>
                    )}
                      </OverlayTrigger>
                    </>}
                    {isDisplayModifyButton && <Button
                      variant='warning'
                      className='px-10 fw-normal h-50px ms-4'
                      onClick={() => onReschedule?.(data)}
                    >
                      {t('VIEW_PACKAGE_MODAL.MODIFY_VISIT')}
                    </Button>}
                  {data.status.startsWith(TicketStatus.Completed)
                   && packageData?.packageDetails.sourceType === TicketSource.B8AK
                   && menuConfig['INVOICE'] != SideMenuStatus.HIDE
                   &&
                    <Button
                      variant='info'
                      className='px-10 fw-normal h-50px ms-4'
                      onClick={handleViewInvoice}
                      disabled={menuConfig['INVOICE'] == SideMenuStatus.DISABLE}
                    >
                      {t('INVOICE')}
                    </Button>
                  }
                </div>
                 
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    </Modal>
    <Modal
      show={showPaymentMethodConfirm}
      onHide={handleDismissPaymentMethodChange}
      centered
      backdrop='static'
      keyboard={false}
      className='payment-method-confirm-modal'
    >
      <Modal.Body className='text-center px-12 py-10'>
        <Icon.ExclamationOctagonFill size={48} className='text-danger mb-6' />
        <h5 className='fw-bold mb-4'>{t('VIEW_PACKAGE_MODAL.PAYMENT_METHOD_CHANGE_CONFIRM_TITLE')}</h5>
        <p className='text-muted mb-0'>{t('VIEW_PACKAGE_MODAL.PAYMENT_METHOD_CHANGE_CONFIRM_SUBTITLE')}</p>
      </Modal.Body>
      <Modal.Footer className='border-0 px-10 pb-10 pt-2'>
        <Button variant='light' className='payment-method-confirm-modal__btn' onClick={handleDismissPaymentMethodChange}>
          {t('BACK')}
        </Button>
        <Button variant='dark' className='payment-method-confirm-modal__btn' onClick={handleConfirmPaymentMethodChange}>
          {t('VIEW_PACKAGE_MODAL.PAYMENT_METHOD_CHANGE_CONFIRM_ACTION')}
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export { ViewPackageModal }
